export function excludeLetters(text) {
    return text.replace(/[a-zA-Z]/g, "");
}
//# sourceMappingURL=LettersExcluder.js.map